<template>
  <div class="flex flex-col" :class="size">
    <slot name="label">
      <label :for="props.name" :class="props.classes">{{ label }}</label>
    </slot>
    <slot>
      <Select
        :name="props.name"
        :id="props.name"
        type="text"
        :options="options"
        :optionLabel="optionsLabel"
        :placeholder="placeholder"
        :showClear="showClear"
        :disabled="disabled"
        :scrollHeight
        v-model="value"
        class="h-10"
        @change="emit('change')"
      ></Select>
    </slot>
  </div>
</template>

<script setup lang="ts">
interface Props {
  name: string;
  value?: string;
  label: string;
  size?: string;
  classes?: string;
  options: any[];
  optionsLabel: string | ((data: any) => string);
  placeholder?: string;
  showClear?: boolean;
  disabled?: boolean;
  scrollHeight?: string;
}
const props = withDefaults(defineProps<Props>(), {
  size: "w-full",
  classes: "font-bold",
  placeholder: " ",
  showClear: false,
  disabled: false,
  scrollHeight: "30rem",
});

const emit = defineEmits<{
  change: [];
}>();

const value = defineModel<Object | undefined>({ required: true });
</script>
